import { equal, not } from "@ember/object/computed";
import RestModel from "discourse/models/rest";
export const MAX_MESSAGE_LENGTH = 500;
export default class PostActionType extends RestModel {
  static #_ = (() => dt7948.g(this.prototype, "notCustomFlag", [not("is_custom_flag")]))();
  #notCustomFlag = (() => (dt7948.i(this, "notCustomFlag"), void 0))();
  static #_2 = (() => dt7948.g(this.prototype, "isIllegal", [equal("name_key", "illegal")]))();
  #isIllegal = (() => (dt7948.i(this, "isIllegal"), void 0))();
}